module.exports = __webpack_public_path__ + "static/img/YB-2000.e880bc50.png";